export const CONTACTS_LOADING = "CONTACTS_LOADING";
export const CONTACTS_ERROR = "CONTACTS_ERROR";
export const GET_CONTACTS = "GET_CONTACTS";
export const GET_CONTACT_DETAIL = "GET_CONTACT_DETAIL";
export const UPDATE_CONTACT_DETAIL = "UPDATE_CONTACT_DETAIL";
